<template>
  <div class="singin">
    <breadcrumb></breadcrumb>
    <div class="singin-box tpl-detail">
      <h5 class="">
        <span>
          <span class="tit">已上传成果</span>
          <!-- <el-select
            @change="selectData"
            v-model="singnInType"
            placeholder="请选择"
            size="small"
          >
            <el-option
              v-for="item in singnInOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select> -->
        </span>
        <!-- <div class="right-box">
          <el-button
            :disabled="uploaded.length == 0"
            type="primary"
            size="small"
            @click="exportExcel('#table1', '已上传成果')"
            >导出excel名单</el-button
          >
        </div> -->
      </h5>
      <div class="content clearfix">
        <div class="img-box fl" v-for="i in uploaded" :key="i.id">
          <img
            :src="
              i.userLogo ? i.userLogo + '?imageView2/1/w/70/h/70' : userLogo
            "
            alt
          />
          <br />
          <h3>{{ i.userName }}</h3>
        </div>
      </div>
    </div>
    <div class="singin-box tpl-detail">
      <h5 class="">
        <span class="tit">未上传成果</span>
        <!-- <div class=" ">
          <el-button
            :disabled="notUpload.length == 0"
            type="primary"
            @click="exportExcel('#table2', '未上传成果')"
            size="small"
            >导出excel名单</el-button
          >
        </div> -->
      </h5>
      <div class="content clearfix">
        <div class="img-box fl" v-for="i in notUpload" :key="i.id">
          <img
            :src="
              i.userLogo ? i.userLogo + '?imageView2/1/w/70/h/70' : userLogo
            "
            alt
          />
          <br />
          <h3>{{ i.userName }}</h3>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue'
import { getData } from '@/http/fetch.js'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export default {
  components: {
    Breadcrumb
  },
  computed: {
    modleType() {
      return this.$route.query.type
    }
  },
  data() {
    return {
      singnInType: '',
      singnInOptions: [
        //{ code: "0", name: "全部" },
        { code: '1', name: '签到' },
        { code: '2', name: '签退' }
      ],
      uploaded: [],
      notUpload: [],
      userLogo: require('@/assets/image/other/man_teacher.png'),
      //项目课题研究 子活动 列表
      activeCode: '', //子活动code
      actList: []
    }
  },
  created() {
    this.selectData()
  },
  methods: {
    async selectData() {
      let { notUpload, uploaded } = await getData(
        '/research/getActiveResultsStatistics',
        {
          actCode: this.activeCode || sessionStorage.getItem('actCode')
        }
      )
      this.uploaded = uploaded
      this.notUpload = notUpload
    },
    exportExcel(domId, tableName) {
      var wb = XLSX.utils.table_to_book(document.querySelector(domId))

      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: 'application/octet-stream' }),
          tableName + '.xlsx'
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }

      return wbout
    }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
.singin {
  // padding: 10px 20px;
  .topic-actlist {
    //   border:1px solid red;
    padding-top: 5px;
    padding-left: 20px;
    margin-top: 10px;
    background: #fff;

    ::v-deep .el-tabs__header {
      margin-bottom: 5px !important;
    }
    ::v-deep .el-tabs__item {
      font-size: 16px;
    }
  }
  .singin-box {
    margin: 15px 0px;
    background-color: #fff;

    .content {
      padding: 25px;
      background-color: #fff;
      //   border: 1px solid #000;
      height: 385px;
      overflow-y: auto;
      .img-box {
        border: 1px solid #eee;
        width: 70px;
        padding: 7.5px;
        border-radius: 5px;
        margin: 0px 15px 15px 0px;
        img {
          width: 100%;
          height: 70px;
          width: 70px;
          border-radius: 50%;
        }
        h3 {
          margin-top: 5px;
          font-size: 13px;
          text-align: center;
          width: 100%; //需要指定宽度
          overflow: hidden; //溢出隐藏
          text-overflow: ellipsis;
          white-space: nowrap; //强制不换行
        }
      }
    }
  }
}
</style>
